// extracted by mini-css-extract-plugin
module.exports = {"autocite":"style__autocite___2igD7"};